import * as actionTypes from '../actions/actionTypes';

const intiData = {
  data: {
    formData: {
    otherAccounts: [],
    availableAccounts:[],
    availableAddresses:[],
    availableContacts:[]
   }
  },
  statuses: {
    basicDetails: {
      status: "incomplete"
    },
    addressAndContacts: {
      status: "incomplete"
    },
    creditTransferReports: {
      status: "incomplete"
    },
    creditTransferSpecific: {
      status: "incomplete"
    },
    primaryAndAdditionalContact: {
      status: "incomplete"
    },
    mandateServiceUserTraining: {
      status: "incomplete"
    }
  },
  currentDropDown: ''
};

export default function currentProductAchReducer(state = intiData, action) {
  switch(action.type){
    case actionTypes.SET_CURRENT_PRODUCT_ACH: {
      let newState = {...state};
      newState.data = action.data;
      return newState;
    }
    case actionTypes.SET_OTHER_ACCOUNT_ACH: {
      let combineNewOtherAcc = [...action.accounts,...state.data.formData.availableAccounts];
      let removeDuplicate = new Map();
      for(let acc of combineNewOtherAcc){
        if(!removeDuplicate.has(acc.id)){
          removeDuplicate.set(acc.id,acc);
        }
      };
      let updatedtAccountList = [];
      for(let [k,v] of removeDuplicate.entries()){
        updatedtAccountList.push(v);
      }

      let updateAccount = {
        ...state,
        data:{
          ...state.data,
          formData:{
            ...state.data.formData,
            availableAccounts:[
              ...updatedtAccountList
            ]
          }
        }
      }
      return updateAccount;
    }

    case actionTypes.SET_ACH_CREDIT_ACTIVE_TAB_INDEX:{
      let newState = {...state};
      newState.activeTabIndex = action.index;
      return newState;
    }

    case actionTypes.RESET_ACH_CREDIT_ACTIVE_TAB_INDEX:{
      let newState = {...state};
      newState.activeTabIndex =-1;
      return newState;
    }

    case actionTypes.RESET_CURRENT_ACH_PRODUCT : {
      return intiData;
    }

    case actionTypes.SET_CURRENT_DROPDOWNSELECT: {
      let newState = { ...state };
      newState.currentDropDown = action.data
      return newState;
    }

    case actionTypes.RESET_CURRENT_DROPDOWNSELECT: {
      let newState = { ...state };
      newState.currentDropDown = ''
      return newState;
    }

    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/CaseBody/reducers/currentProductAchReducer.js